var map = {
	"./ada.png": "9a84",
	"./comingSoon.svg": "2160",
	"./complete.png": "86e8",
	"./disableADA.png": "6d9e",
	"./eforms.png": "3d49",
	"./en.png": "70ff",
	"./es.png": "b8cf",
	"./law-book.png": "8f36",
	"./logo.png": "cf05",
	"./nv.png": "521a",
	"./pdf.png": "9f06",
	"./qrcode.svg": "2a97",
	"./reset.png": "ffc4",
	"./stopTalking.png": "0e69",
	"./talkButton.png": "4ce5",
	"./talkButtonActive.webp": "6770",
	"./vi.png": "5207",
	"./video.png": "01f0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";